import React, { useState } from "react";
import { SmartTableFilter } from "../../../../../elements/smart-table/components/SmartTableFilter/SmartTableFilter";
import { SmartTable } from "../../../../../elements/smart-table/SmartTable";
import { useGetAdminMessagesTableColumns } from "./utilities/useGetAdminMessagesTableColumns";
import { useGetAdminMessagesTableData } from "./utilities/useGetAdminMessagesTableData";

export const AdminMessagesTable = ({ ajax, initialFilter }) => {
  const [filter, setFilter] = useState({ ...initialFilter, Skip: 0, Take: 10 });
  const { data, isLoading, error } = useGetAdminMessagesTableData(filter, ajax);
  const columns = useGetAdminMessagesTableColumns();

  return (
    <SmartTableFilter currentFilter={filter} onChange={(value) => setFilter(value)} total={data.Total}>
      <SmartTable data={data.Collection} columns={columns} isLoading={isLoading} error={error} />
    </SmartTableFilter>
  );
};
